<form [formGroup]="form" autocomplete="off">

    <p-dialog showHeader="false" [(visible)]="display" [modal]="true" width="300" [baseZIndex]="10000"
              header="Acceso Cexveg" #dialDetail>

        <div class="animated fadeIn">

            <div class="row">

                <div class="form-group col-md-12">

                    <div class="row">

                        <div class="form-group col-md-12">
                            <label class="col-form-label required-field">Nombre de Usuario</label>
                            <input formControlName="NombreUsuario" name="Descripcion" title="" class="form-control"
                                   [ngClass]="displayFieldCss('NombreUsuario')"
                                   id="NombreUsuario"
                                   maxlength="50" autocomplete="new-password" auto-suggest="off"
                                   type="text" value="">

                            <div class="invalid-feedback" *ngIf="isFieldInvalid('NombreUsuario','required')">
                                Nombre de Usuario es obligatorio
                            </div>

                        </div>
                    </div>

                    <div class="row">

                        <div class="form-group col-md-12">
                            <label class="col-form-label required-field">Contraseña</label>
                            <input formControlName="Password" name="Password" (keyup.enter)="onLogin()" title="" class="form-control"
                                   autocomplete="new-password" auto-suggest="off"
                                   [ngClass]="displayFieldCss('Password')" id="inpPassword" type="password" value="">

                            <div class="invalid-feedback" *ngIf="isFieldInvalid('Password','required')">
                                Contraseña obligatoria
                            </div>
                        </div>

                    </div>

                </div>

            </div>

        </div>

        <p-footer>
            <button pButton (click)="onLogin()" [disabled]="noAccepted()" label="Aceptar" class="p-confirm-dialog-accept" icon="pi pi-check" title="Aceptar"></button>
            <button pButton (click)="cancelDialog()" label="Cancelar" class="p-confirm-dialog-reject" icon="pi pi-times" title="Cancelar"></button>
        </p-footer>

    </p-dialog>

</form>
